<template>
  <el-main>
    <template v-if="setting.isSimple">
      <div style="padding: 0px 1rem;margin-top: 0.3rem;">
        <div class="right bottom-pad el-row" style="position: sticky;">
          <el-button v-if="!isEdit" size="small" @click="editBtn" type="primary" icon="el-icon-edit">编 辑</el-button>
          <!-- <el-button @click="editBtn"  type="button" class="el-button el-button--primary el-button--small"><i class="el-icon-edit"></i><span>编 辑</span></el-button> -->
          <template v-else>
            <el-button @click="save" size="small" type="success" icon="el-icon-check">保 存</el-button>
            <el-button @click="isEdit = false" type="danger" size="small" icon="el-icon-close">取 消</el-button>
          </template>

        </div>
        <el-descriptions v-if="!isEdit" title="患者信息" :column="4" contentClassName="right-pad">
          <el-descriptions-item label="姓名">
            {{ patient.name }}
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            {{ patient.gender | dictText("Gender") }}
          </el-descriptions-item>
          <el-descriptions-item label="证件号">
            {{ patient.idNo }}
          </el-descriptions-item>
          <el-descriptions-item label="年龄">
            {{ patient.patientAge }}
          </el-descriptions-item>
          <el-descriptions-item label="民族">
            {{ patient.ethnicity | dictText("Ethnicity") }}
          </el-descriptions-item>
          <el-descriptions-item label="传染病">
            {{ entity.epidemic }}
          </el-descriptions-item>
          <el-descriptions-item label="新冠">
            {{ entity.covid19 | dictText("Covid19") }}
          </el-descriptions-item>
          <el-descriptions-item label="药物过敏">
            {{ entity.allergyDrugs }}
          </el-descriptions-item>
          <el-descriptions-item label="体温">
            {{ entity.temperature }}
          </el-descriptions-item>
          <el-descriptions-item label="症状">
            {{ entity.symptoms }}
          </el-descriptions-item>
          <el-descriptions-item label="出生年月日">
            {{ entity.birthDate }}
          </el-descriptions-item>
          <el-descriptions-item label="分组">
            {{ entity.groupType }}
          </el-descriptions-item>

          <el-descriptions-item label="目标分级">
            {{ entity.targetGrade | dictText("TargetGrade") }}
          </el-descriptions-item>
          <el-descriptions-item label="办案人单位">
            {{ entity.contactCompany }}
          </el-descriptions-item>
          <el-descriptions-item label="办案人">
            {{ entity.contactName }}
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            {{ entity.contactPhone }}
          </el-descriptions-item>

          <el-descriptions-item label="接收既往病历">
            {{ entity.ifMedicalRecordReceived ? '是' : '否'}}
          </el-descriptions-item>
          <el-descriptions-item label="接收人">
            {{ entity.medicalRecordReceivedUserName }}
          </el-descriptions-item>
          <el-descriptions-item label="接收日期">
            {{ entity.medicalRecordReceivedDate }}
          </el-descriptions-item>
        </el-descriptions>
        <template v-else>
          <el-form class="left" ref="editor" :rules="rules" size="small" :model="editInfo" label-width="8rem">
            <el-row>
              <el-col :span="8" style="height: 51px">
                <el-form-item label="姓名" prop="patientName">
                  <el-input maxlength="200" v-model="editInfo.patientName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别" prop="patientGender">
                  <hic-dict-selector v-model="editInfo.patientGender" auto dict-type="Gender" class="edit-select" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件号" prop="idNo">
                  <el-input maxlength="30" v-model="editInfo.idNo" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="年龄" prop="patientAge">
                  <el-input maxlength="30" v-model="editInfo.patientAge" clearable type="number"
                    @blur="ageChange"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="民族" prop="ethnicity">
                  <hic-dict-selector dict-type="Ethnicity" v-model="editInfo.ethnicity" placeholder="请选择"
                    auto></hic-dict-selector>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="传染病" prop="epidemic">
                  <hic-text-selector dict-type="Epidemic" v-model="editInfo.epidemic" placeholder="请选择"
                    :multiple="true"></hic-text-selector>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="新冠" prop="covid19">
                  <hic-dict-selector dict-type="Covid19" v-model="editInfo.covid19" placeholder="请选择"
                    auto></hic-dict-selector>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="药物过敏" prop="">
                  <hic-text-selector dict-type="AllergyDrugs" v-model="editInfo.allergyDrugsList" placeholder="请选择"
                    multiple></hic-text-selector>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="体温" prop="temperature">
                  <el-input maxlength="6" type="number" v-model="editInfo.temperature" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="症状" prop="symptoms">
                  <el-input v-model="editInfo.symptoms" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生年月日" prop="birthDate">
                  <el-date-picker v-model="editInfo.birthDate" style="width: 100%;" type="date" size="small"
                    value-format="yyyy-MM-dd" placeholder="选择出生年月日" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分组" prop="groupType">
                  <hic-dict-selector dict-type="PatientGroup" is-enum v-model="editInfo.groupType"
                    placeholder="请选择"></hic-dict-selector>
                </el-form-item>
              </el-col>


              <el-col :span="8">
                <el-form-item label="目标分级" prop="">
                  <hic-dict-selector dict-type="TargetGrade" v-model="editInfo.targetGrade"
                    placeholder="请选择"></hic-dict-selector>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="办案人单位" prop="contactCompany">
                  <el-input maxlength="30" v-model="editInfo.contactCompany" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="办案人" prop="contactName">
                  <el-input maxlength="30" v-model="editInfo.contactName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话" prop="contactPhone">
                  <el-input maxlength="30" v-model="editInfo.contactPhone" clearable style="width: 80%"></el-input>
                  <!-- <el-button @click="addContact" icon="el-icon-plus" size="mini" type="primary" circle plain
                    class="left-pad"></el-button> -->
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="接收既往病历" prop="ifMedicalRecordReceived">
                  <el-radio-group v-model="editInfo.ifMedicalRecordReceived" @input="changedMedicalRecordReceived">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="接收人" prop="medicalRecordReceivedUserCode">
                  <hic-staff-selector :dept="editInfo.deptCode" v-model="editInfo.medicalRecordReceivedUserCode" :name.sync="editInfo.medicalRecordReceivedUserName" :disabled="!editInfo.ifMedicalRecordReceived" class="f-w"></hic-staff-selector>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="接收日期" prop="medicalRecordReceivedDate">
                  <el-date-picker v-model="editInfo.medicalRecordReceivedDate" style="width: 100%;" type="date" size="small" value-format="yyyy-MM-dd" placeholder="接收日期" :disabled="!editInfo.ifMedicalRecordReceived" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <br />
        <el-descriptions title="住院信息" :column="4" contentClassName="right-pad">
          <el-descriptions-item label="当前科室">
            {{ entity.deptCode | dictText("Dept") }}
          </el-descriptions-item>
          <el-descriptions-item label="当前病区">
            {{ entity.wardCode | dictText("IpWard") }}
          </el-descriptions-item>
          <el-descriptions-item label="当前床位">
            {{ entity.bedNo }}
            <el-link type="primary" icon="el-icon-edit" class="left-pad" @click="meta.bedChanging = true"
              style="margin-top: -0.5rem">调整</el-link>
          </el-descriptions-item>
          <el-descriptions-item label="入科日期">
            {{ entity.checkInDate | fmtDate }}
          </el-descriptions-item>

          <el-descriptions-item label="责任医师">
            {{ entity.doctorName }}
            <el-popover title="责任医师" trigger="click" placement="top-start">
              <el-row>
                <el-col :span="12">
                  <hic-staff-selector :dept="user.deptCode" v-model="staff.doctor" :name.sync="staff.doctorName"
                    class="f-w" />
                </el-col>
                <el-col :span="12" class="center">
                  <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                  <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                    :disabled="!entity.doctorCode">人员调岗</el-button>
                </el-col>
              </el-row>
              <el-link slot="reference" type="primary" icon="el-icon-edit" class="left-pad">更换</el-link>
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="责任护士">
            {{ entity.nurseName }}
            <el-popover title="责任护士" trigger="click" placement="top-start">
              <el-row>
                <el-col :span="12">
                  <hic-staff-selector :dept="user.deptCode" v-model="staff.nurse" :name.sync="staff.nurseName" />
                </el-col>
                <el-col :span="12" class="center">
                  <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                  <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                    :disabled="!entity.nurseCode">人员调岗</el-button>
                </el-col>
              </el-row>
              <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
                class="left-pad">更换</el-link>
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="主治医师">
            {{ entity.masterName }}
            <el-popover title="主治医师" trigger="click" placement="top-start">
              <el-row>
                <el-col :span="12">
                  <hic-staff-selector :dept="user.deptCode" v-model="staff.master" :name.sync="staff.masterName" />
                </el-col>
                <el-col :span="12" class="center">
                  <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                  <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                    :disabled="!entity.masterCode">人员调岗</el-button>
                </el-col>
              </el-row>
              <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
                class="left-pad">更换</el-link>
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="主任医师">
            {{ entity.directorName }}
            <el-popover title="主任医师" trigger="click" placement="top-start">
              <el-row>
                <el-col :span="12">
                  <hic-staff-selector :dept="user.deptCode" v-model="staff.director" :name.sync="staff.directorName" />
                </el-col>
                <el-col :span="12" class="center">
                  <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                  <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                    :disabled="!entity.directorCode">人员调岗</el-button>
                </el-col>
              </el-row>
              <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
                class="left-pad">更换</el-link>
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="危重等级">
            {{ entity.criticalLevel }}
          </el-descriptions-item>
          <el-descriptions-item label="护理等级">
            {{ entity.nursingGrade }}
          </el-descriptions-item>
          <el-descriptions-item label="就诊类型">
            {{ entity.ipType | dictText("IpType") }}
          </el-descriptions-item>
          <el-descriptions-item label="住院类型">
            {{ entity.stayType | dictText("IpStayType") }}
          </el-descriptions-item>
          <el-descriptions-item label="入院日期">
            {{ entity.startDate | fmtDate }}
            <el-popover title="入院时间" trigger="click" placement="top-start">
              <el-date-picker v-model="startDate" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间" />
              <el-button type="primary" icon="el-icon-check" plain size="mini" class="left-pad"
                @click="changeDate()">确定</el-button>
              <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
                class="left-pad">修改</el-link>
            </el-popover>
          </el-descriptions-item>
          <el-descriptions-item label="入院方式">
            {{ entity.admissionMode }}
          </el-descriptions-item>
          <el-descriptions-item label="入院次数">
            {{ entity.stayTimes }}
          </el-descriptions-item>
          <el-descriptions-item label="入院途径">
            {{ entity.comeFrom | dictText("IpComeFrom") }}
          </el-descriptions-item>
          <el-descriptions-item label="离院日期">
            {{ entity.endDate | fmtDate }}
          </el-descriptions-item>
          <el-descriptions-item label="离院方式">
            {{ entity.leaveMode }}
          </el-descriptions-item>
          <el-descriptions-item label="在院天数">
            {{ entity.days }}
          </el-descriptions-item>
          <el-descriptions-item label="费用合计">
            {{ entity.amount | fmtFloat(2) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </template>
    <hic-patient-panel v-else :isSimple="setting.isSimple" :id="entity.patientCode" hide-other show-edit-bar
      @saved="updateHospitalization" style="margin-top: 0.3rem">
      <el-descriptions title="住院信息" :column="4" contentClassName="right-pad">
        <el-descriptions-item label="当前科室">
          {{ entity.deptCode | dictText("Dept") }}
        </el-descriptions-item>
        <el-descriptions-item label="当前病区">
          {{ entity.wardCode | dictText("IpWard") }}
        </el-descriptions-item>
        <el-descriptions-item label="当前床位">
          {{ entity.bedNo }}
          <el-link v-if="!readonly" type="primary" icon="el-icon-edit" class="left-pad" @click="meta.bedChanging = true"
            style="margin-top: -0.5rem">调整</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="入科日期">
          {{ entity.checkInDate | fmtDate }}
        </el-descriptions-item>

        <el-descriptions-item label="责任医师">
          {{ entity.doctorName }}
          <el-popover v-if="!readonly" title="责任医师" trigger="click" placement="top-start">
            <el-row>
              <el-col :span="12">
                <hic-staff-selector :dept="user.deptCode" v-model="staff.doctor" :name.sync="staff.doctorName"
                  class="f-w" />
              </el-col>
              <el-col :span="12" class="center">
                <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                  :disabled="!entity.doctorCode">人员调岗</el-button>
              </el-col>
            </el-row>
            <el-link slot="reference" type="primary" icon="el-icon-edit" class="left-pad">更换</el-link>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="责任护士">
          {{ entity.nurseName }}
          <el-popover v-if="!readonly" title="责任护士" trigger="click" placement="top-start">
            <el-row>
              <el-col :span="12">
                <hic-staff-selector :dept="user.deptCode" v-model="staff.nurse" :name.sync="staff.nurseName" />
              </el-col>
              <el-col :span="12" class="center">
                <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                  :disabled="!entity.nurseCode">人员调岗</el-button>
              </el-col>
            </el-row>
            <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
              class="left-pad">更换</el-link>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="主治医师">
          {{ entity.masterName }}
          <el-popover v-if="!readonly" title="主治医师" trigger="click" placement="top-start">
            <el-row>
              <el-col :span="12">
                <hic-staff-selector :dept="user.deptCode" v-model="staff.master" :name.sync="staff.masterName" />
              </el-col>
              <el-col :span="12" class="center">
                <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                  :disabled="!entity.masterCode">人员调岗</el-button>
              </el-col>
            </el-row>
            <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
              class="left-pad">更换</el-link>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="主任医师">
          {{ entity.directorName }}
          <el-popover v-if="!readonly" title="主任医师" trigger="click" placement="top-start">
            <el-row>
              <el-col :span="12">
                <hic-staff-selector :dept="user.deptCode" v-model="staff.director" :name.sync="staff.directorName" />
              </el-col>
              <el-col :span="12" class="center">
                <el-button type="primary" icon="el-icon-check" plain size="mini" @click="changeStaff()">更换</el-button>
                <el-button type="success" icon="el-icon-user" plain size="mini" @click="changeStaff(true)"
                  :disabled="!entity.directorCode">人员调岗</el-button>
              </el-col>
            </el-row>
            <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
              class="left-pad">更换</el-link>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="危重等级">
          {{ entity.criticalLevel }}
        </el-descriptions-item>
        <el-descriptions-item label="护理等级">
          {{ entity.nursingGrade }}
        </el-descriptions-item>
        <el-descriptions-item label="就诊类型">
          {{ entity.ipType | dictText("IpType") }}
        </el-descriptions-item>
        <el-descriptions-item label="住院类型">
          {{ entity.stayType | dictText("IpStayType") }}
        </el-descriptions-item>
        <el-descriptions-item label="入院日期">
          {{ entity.startDate | fmtDate }}
          <el-popover v-if="!readonly" title="入院时间" trigger="click" placement="top-start">
            <el-date-picker v-model="startDate" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间" />
            <el-button type="primary" icon="el-icon-check" plain size="mini" class="left-pad"
              @click="changeDate()">确定</el-button>
            <el-link slot="reference" type="primary" size="mini" round plain icon="el-icon-edit"
              class="left-pad">修改</el-link>
          </el-popover>
        </el-descriptions-item>
        <el-descriptions-item label="入院方式">
          {{ entity.admissionMode }}
        </el-descriptions-item>
        <el-descriptions-item label="入院次数">
          {{ entity.stayTimes }}
        </el-descriptions-item>
        <el-descriptions-item label="入院途径">
          {{ entity.comeFrom | dictText("IpComeFrom") }}
        </el-descriptions-item>
        <el-descriptions-item label="离院日期">
          {{ entity.endDate | fmtDate }}
        </el-descriptions-item>
        <el-descriptions-item label="离院方式">
          {{ entity.leaveMode }}
        </el-descriptions-item>
        <el-descriptions-item label="在院天数">
          {{ entity.days }}
        </el-descriptions-item>
        <el-descriptions-item label="费用合计">
          {{ entity.amount | fmtFloat(2) }}
        </el-descriptions-item>
      </el-descriptions>
    </hic-patient-panel>
    <hic-hospitalization-beds-dialog :visible.sync="meta.bedChanging" :hospitalization="entity"
      :hide-wrap="setting.isSimple" />
  </el-main>
</template>
<script>
import api from "../api";
import { mapGetters } from "sw-hic";
export default {
  props: {
    entity: Object,
  },
  data() {
    // 自定义体温验证函数（核心适配）
    const validateTemperature = (rule, value, callback) => {
      // 去除首尾空格
      const tempValue = (value || '').toString().trim();

      // 空值已由 required 规则校验
      if (tempValue) {
        // 1. 校验是否为有效数字（支持整数、一位/两位小数，如 36、36.5、36.55）
        const numReg = /^(\d{2})(\.\d{1,2})?$/;
        if (!numReg.test(tempValue)) {
          return callback(new Error('体温格式错误，请输入有效数字（如 36、36.5）'));
        }

        // 2. 转换为数字并校验范围（35.0℃ ~ 42.0℃）
        const tempNum = parseFloat(tempValue);
        if (tempNum < 35.0) {
          return callback(new Error('体温过低，正常范围为 35.0℃ ~ 42.0℃'));
        }
        if (tempNum > 42.0) {
          return callback(new Error('体温过高，正常范围为 35.0℃ ~ 42.0℃'));
        }
      }
      // 验证通过
      callback();
    };
    return {
      meta: {
        doctorChanging: false,
        nurseChanging: false,
        bedChanging: false,
      },
      readonly() {
        return this.entity?.state == "已离院" || this.entity?.state == "已结算";
      },
      staff: {
        doctor: null,
        master: null,
        director: null,
        nurse: null,
      },
      startDate: null,
      patient: {},
      isEdit: false,
      editInfo: {},
      rules: {
        patientName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        patientAge: [{ required: true, message: "请填写年龄", trigger: "blur" }],
        patientGender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        idNo: [{ required: true, message: "请填写证件号", trigger: "blur" }],
        contactCompany: [{ required: true, message: "请填写办案人单位", trigger: "blur" }],
        contactName: [{ required: true, message: "请填写办案人", trigger: "blur" }],
        contactPhone: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
        epidemic: [{ required: true, message: "请选择传染病", trigger: "change" }],
        covid19: [{ required: true, message: "请选择新冠", trigger: "change" }],
        groupType: [{ required: true, message: "请选择分组", trigger: "change" }],
        symptoms: [{ required: true, message: "请输入", trigger: "change" }],
        temperature: [{ required: true, message: "请输入", trigger: "change" }, { validator: validateTemperature, trigger: ["blur", "change"] }],
        birthDate: [{ required: true, message: "请选择出生年月日", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapGetters(["user", "setting"]),
    days() {
      return this.$utils.Dt.span(this.entity.startDate, this.entity.endDay || this.$utils.Dt.now(), "d");
    },
  },
  watch: {
    entity() {
      this.getPatient();
    },
  },
  mounted() {
    this.getPatient();
  },
  methods: {
    dateBrithday(val) {
      if (val) {
        let _arr = val.split('-')
        return _arr[0] + '-' + _arr[1]
      }
    },
    getPatient() {
      api.Patient.get(this.entity.patientCode).then((res) => {
        this.patient = res;
      })
    },
    // allergyDrugsName(val) {
    //   const list = val ? val.split(',') : []
    //   return list.map(item => this.$utils.Dict.text(item, 'AllergyDrugs')).join(',')
    // },
    editBtn() {
      if (!this.patient.name) return
      this.editInfo = {
        patientName: this.patient.name,
        idNo: this.patient.idNo,
        patientAge: parseInt(this.patient.patientAge),
        patientGender: this.patient.gender,
        ethnicity: this.patient.ethnicity,

        epidemic: this.entity.epidemic ? this.entity.epidemic.split(',') : [],
        covid19: this.entity.covid19,
        allergyDrugsList: this.entity.allergyDrugs ? this.entity.allergyDrugs.split(',') : [],
        targetGrade: this.entity.targetGrade,
        contactCompany: this.entity.contactCompany,
        contactName: this.entity.contactName,
        contactPhone: this.entity.contactPhone,

        groupType: this.entity.groupType || null,
        symptoms: this.entity.symptoms || null,
        temperature: this.entity.temperature || null,

        ifMedicalRecordReceived: this.entity.ifMedicalRecordReceived,
        medicalRecordReceivedUserCode: this.entity.medicalRecordReceivedUserCode || null,
        medicalRecordReceivedUserName: this.entity.medicalRecordReceivedUserName || null,
        medicalRecordReceivedDate: this.entity.medicalRecordReceivedDate || null,
      }      
      if (this.entity.birthDate) this.$set(this.editInfo,"birthDate",this.entity.birthDate)

      this.isEdit = true
    },
    ageChange() {
      let nowYear = this.$utils.Dt.today().substring(0, 4);
      let birthYear = parseInt(nowYear) - parseInt(this.editInfo.patientAge);
      this.$set(this.editInfo, "birthday", birthYear + "-01-01");
    },
    save() {
      this.$set(this.patient, 'name', this.editInfo.patientName)
      this.$set(this.patient, 'gender', this.editInfo.patientGender)
      this.$set(this.patient, 'idNo', this.editInfo.idNo)
      this.$set(this.patient, 'patientAge', this.editInfo.patientAge)
      this.$set(this.patient, 'ethnicity', this.editInfo.ethnicity)

      this.$set(this.patient, 'groupType', this.editInfo.groupType || null)
      this.$set(this.patient, 'symptoms', this.editInfo.symptoms || null)
      this.$set(this.patient, 'temperature', this.editInfo.temperature || null)
      this.$set(this.patient, 'birthDate', this.editInfo.birthDate || null)

      this.$set(this.patient, 'ifMedicalRecordReceived', this.editInfo.ifMedicalRecordReceived)
      this.$set(this.patient, 'medicalRecordReceivedUserCode', this.editInfo.medicalRecordReceivedUserCode || null)
      this.$set(this.patient, 'medicalRecordReceivedUserName', this.editInfo.medicalRecordReceivedUserName || null)
      this.$set(this.patient, 'medicalRecordReceivedDate', this.editInfo.medicalRecordReceivedDate || null)

      if (this.editInfo.birthday) this.$set(this.patient, 'birthday', this.editInfo.birthday)


      this.$refs.editor.validate((valid) => {
        if (valid) {
          api.Patient.save(this.patient).then((res) => {
            this.entity.epidemic = this.editInfo.epidemic ? this.editInfo.epidemic.join(',') : ''
            this.entity.covid19 = this.editInfo.covid19
            this.entity.allergyDrugs = this.editInfo.allergyDrugsList ? this.editInfo.allergyDrugsList.join(',') : ''
            this.entity.targetGrade = this.editInfo.targetGrade

            this.entity.contactCompany = this.editInfo.contactCompany
            this.entity.contactName = this.editInfo.contactName
            this.entity.patientIdNo = this.editInfo.idNo
            this.entity.contactPhone = this.editInfo.contactPhone

            this.entity.groupType = this.editInfo.groupType || null
            this.entity.birthDate = this.editInfo.birthDate || null
            this.entity.symptoms = this.editInfo.symptoms || null
            this.entity.temperature = this.editInfo.temperature || null

            this.entity.ifMedicalRecordReceived = this.editInfo.ifMedicalRecordReceived
            this.entity.medicalRecordReceivedUserCode = this.editInfo.medicalRecordReceivedUserCode || null
            this.entity.medicalRecordReceivedUserName = this.editInfo.medicalRecordReceivedUserName || null
            this.entity.medicalRecordReceivedDate = this.editInfo.medicalRecordReceivedDate || null

            this.updateHospitalization(res)
          })
        }
      });

    },
    updateHospitalization(patient) {
      this.entity.patientName = patient.name;
      this.entity.patientGender = patient.gender;
      this.entity.patientBirthday = patient.birthday;
      this.entity.patientAllergyDrugs = patient.allergyDrugs;
      this.entity.patientBloodType = patient.bloodType + patient.bloodRh;
      this.entity.patientIdNo = patient.idNo;
      api.Hospitalization.save(this.entity)
        .then((res) => {
          this.entity = res;
          this.entity.lockKey = res.lockKey;
          this.isEdit = false
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeStaff(isAll) {
      let part = { id: this.entity.id };
      let who = "";
      if (this.staff.doctor && this.staff.doctor != this.entity.doctorCode) {
        who = "doctor";
      } else if (this.staff.master && this.staff.master != this.entity.masterCode) {
        who = "master";
      } else if (this.staff.director && this.staff.director != this.entity.directorCode) {
        who = "director";
      } else if (this.staff.nurse && this.staff.nurse != this.entity.nurseCode) {
        who = "nurse";
      } else {
        return;
      }
      part[`${who}Code`] = this.staff[`${who}`];
      part[`${who}Name`] = this.staff[`${who}Name`];

      let oName = this.entity[`${who}Name`];
      if (!oName) {
        // 原来就是空值的时候，只能改当前记录的值，不能改所有记录的值
        isAll = false;
      }
      if (isAll) {
        let con = { state: "已入住" };
        con[`${who}Code`] = this.entity[`${who}Code`];
        api.Hospitalization.query(con).then((res) => {
          if (res.items.length) {
            let nName = this.staff[`${who}Name`];
            let rName = who == "doctor" ? "责任医师" : who == "master" ? "主治护师" : who == "director" ? "主任医师" : "责任护士";
            let pName = res.items.reduce((p, c) => p + c.patientName + "、", "").slice(0, -1);

            this.$confirm(`${res.items.length} 位在院患者 “${pName}” 的${rName}为【${oName}】。统一替换为【${nName}】，是否继续？`, "人员调岗", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                res.items.forEach((item) => {
                  part.id = item.id;
                  api.Hospitalization.patch(part).then((hos) => {
                    if (item.id == this.entity.id) {
                      this.$message.success("保存成功！");
                      this.$utils.Obj.propertyCopy(hos, this.entity, null, this);
                    }
                  });
                });
              })
              .catch(() => { })
              .finally(() => {
                this.staff = {
                  doctor: null,
                  master: null,
                  director: null,
                  nurse: null,
                };
              });
          }
        });
      } else {
        api.Hospitalization.patch(part)
          .then((res) => {
            this.$message.success("保存成功！");
            this.$utils.Obj.propertyCopy(res, this.entity, null, this);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.staff = {
              doctor: null,
              master: null,
              director: null,
              nurse: null,
            };
          });
      }
    },
    changeDate() {
      if (this.startDate != this.entity.startDate) {
        let part = { id: this.entity.id, startDate: this.startDate };
        api.Hospitalization.patch(part).then((res) => {
          this.entity.lockKey = res.lockKey;
          this.entity.startDate = res.startDate;
        });
      }
    },
    changedMedicalRecordReceived(val) {
      if (!val) {
        this.editInfo.medicalRecordReceivedUserCode = null;
        this.editInfo.medicalRecordReceivedUserName = null;
        this.editInfo.medicalRecordReceivedDate = null;
      }
    },
  },
};
</script>
